
    import styled from "styled-components";

    const ElementorIntegrationPageStyled = styled.div``;

    export { ElementorIntegrationPageStyled };
    